import React from "react";
import { ContentPage } from "@/components/ContentPage";

const sections = [
  {
    id: "eligibility",
    heading: "Rider eligibility",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>Rider must be at least 18 years old for e-bicycles and low-speed scooters.</li>
        <li>Rider must be at least 18 years old and hold a valid Indian driving licence for high-speed scooters and electric motorcycles.</li>
        <li>A valid, government-issued photo ID is required at pickup.</li>
        <li>The vehicle can be operated only by the rider listed on the booking.</li>
      </ul>
    ),
  },
  {
    id: "booking",
    heading: "Booking, pickup & drop-off",
    body: (
      <>
        <p>
          Bookings are confirmed once payment is successful. Doorstep delivery
          and pickup are available in every launch city — the delivery window
          is shared on your booking confirmation.
        </p>
        <p>
          Please inspect the vehicle at handover. Any pre-existing damage
          should be reported to the delivery partner before you sign the
          handover receipt.
        </p>
      </>
    ),
  },
  {
    id: "usage",
    heading: "Usage rules",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>Helmets are mandatory for all riders and pillions.</li>
        <li>Riding under the influence of alcohol or drugs is strictly prohibited.</li>
        <li>Off-road, racing and stunt use is not permitted.</li>
        <li>The vehicle must stay within the city limits of the pickup city unless expressly permitted in writing.</li>
        <li>Overloading beyond the rated payload of the vehicle is prohibited.</li>
      </ul>
    ),
  },
  {
    id: "extensions",
    heading: "Extensions & late returns",
    body: (
      <p>
        Need more time? Extend from the app before your booking ends. Late
        returns beyond the grace period are billed at the highest applicable
        hourly rate for that vehicle.
      </p>
    ),
  },
  {
    id: "damage",
    heading: "Damage & liability",
    body: (
      <p>
        Every rental includes basic insurance. The rider is responsible for
        the excess as defined in the Insurance & Damage Policy. Traffic fines
        and challans issued during the rental are the rider's responsibility.
      </p>
    ),
  },
];

const RentalTerms = () => (
  <ContentPage
    testId="rental-terms-page"
    eyebrow="Rental Terms"
    title="The fine print, kept plain."
    subtitle="These terms apply to every eBikeGo booking. Please read them carefully before you ride."
    sections={sections}
  />
);

export default RentalTerms;
